<template>
    <div>
        <header class="header">
            <img src="static/img/bg.png" alt="">
            <navHeader ref=navHeader></navHeader>
            <div class="phone_box">
                <img src="static/img/phone.png" alt="">
            </div>
            <div class="font_box">
                <img v-if="languageIndex == 0" src="static/img/font.png" alt="">
                <img v-else src="static/img/font1.png" alt="">
            </div>
            <div class="btn_box">
							<template v-if="languageIndex == 0">
									<img src="static/img/ios.png" alt="">
									<img src="static/img/android.png" alt="">
							</template>
               <template v-else>
									<img src="static/img/ios1.png" alt="">
									<img src="static/img/android1.png" alt="">
               </template>
								
            </div>
            <div class="dow_box">
                  <img src="static/img/QR.png" alt="">
                  <p>{{langtrans().ssmewm[languageIndex]}}&nbsp;{{langtrans().xzzddj[languageIndex]}}app</p>
            </div>
        </header>
        <main class="main">
            <ul>
                <li>
                    <img src="static/img/sos.png" alt="">
                    <div>
                        <h4>{{langtrans().yjjyba[languageIndex]}}</h4>
                        <p>{{langtrans().ddjxsg[languageIndex]}}</p>
                    </div>
                </li>
                <li>
                    <img src="static/img/card.png" alt="">
                    <div>
                        <h4>{{langtrans().zxbdcs[languageIndex]}}</h4>
                        <p>{{langtrans().dlyyff[languageIndex]}}</p>
                    </div>
                </li>
                <li>
                    <img src="static/img/star.png" alt="">
                    <div>
                        <h4>{{langtrans().bddxss[languageIndex]}}</h4>
                        <p>{{langtrans().ffbzqq[languageIndex]}}</p>
                    </div>
                </li>
                <li>
                    <img src="static/img/orie.png" alt="">
                    <div>
                        <h4>{{langtrans().qfwjyq[languageIndex]}}</h4>
                        <p>{{langtrans().qsjqqf[languageIndex]}}</p>
                    </div>
                </li>
            </ul>
        </main>
		<vFooter @performHeader=performHeader></vFooter>
    </div>
</template>

<script>
import langtrans from "@/assets/languagejs/dowapp.vue.trans.js";
import { Message } from "element-ui";
import constants from '@/util/constants.js';
import navHeader from '@/components/header/indexHeader'
import vFooter from '@/components/footer/indexFooter'
export default {
  data() {
    return {
      flag: true,
      usertype: "",
      user: "",
      pwd: ""
    };
  },
  components:{
  	navHeader,
  	vFooter
  },
		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},	
  methods: {
		langtrans(){
			return langtrans
		},		
  	performHeader(str){
    	this.$refs.navHeader.login(str)
    },
    feedback() {
      this.$router.push({
        name: "feedback"
      });
    },
    aboutus() {
      this.$router.push({
        name: "aboutus"
      });
    },
    dowapp() {
      this.$router.push({
        name: "dowapp"
      });
    },
    index() {
      this.$router.push({
        name: "Index"
      });
    },
    contact() {
      this.$router.push({
        name: "contact"
      });
    }
  }
};
</script>

<style scoped>
@import url(../../static/css/global.css);
/* @import "../css/index.css"; */
.phone_box {
  position: absolute;
  top: 6.25vw;
  left: 18.75vw;
  width: 18.75vw;
  z-index: 3;
}
.font_box {
  position: absolute;
  top: 10.625vw;
  right: 9.375vw;
  width: 50vw;
}
.font_box img {
  width: 100%;
}
.phone_box img {
  width: 100%;
}
.btn_box {
  position: absolute;
  width: 18.75vw;
  top: 16.875vw;
  left: 41.25vw;
}
.btn_box img {
  display: block;
  width: 100%;
}
.dow_box {
  position: absolute;
  text-align: center;
  width: 15vw;
  top: 17.1875vw;
  right: 16.25vw;
}
.dow_box img {
  width: 10vw;
}
.dow_box p {
  color: #fff;
  text-align: center;
}
.main ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.main{
  padding: 7.45vw 15vw 8vw;
}
.main ul li {
  width: 45%;
  margin-top: 5vw;
  display: flex;
}
.main ul li :nth-child(2n){
  margin-left: 5%;
}
.main ul li img {
  width: 6.25vw;
  height: 6.25vw;
}
.main ul li div h4 {
  font-size: 1.25vw;
  color: #333;
}
.main ul li div p {
  margin-top: 0.75vw;
  font-size: 1vw;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/dowapp.vue